import { render } from "./DisplayedProducts.vue?vue&type=template&id=2c4f9b08&scoped=true"
import script from "./DisplayedProducts.vue?vue&type=script&lang=js"
export * from "./DisplayedProducts.vue?vue&type=script&lang=js"

import "./DisplayedProducts.vue?vue&type=style&index=0&id=2c4f9b08&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2c4f9b08"]])

export default __exports__